import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from ".";
import { AppDispatch } from "..";
import { UserInfoDto } from "../../models/APIModels";

export type UsersState = {
    loading: boolean;
    hasErrors: boolean;
    userInfo: UserInfoDto | null;
};
//

export const initialState: UsersState = {
    loading: false,
    hasErrors: false,
    userInfo: null,
};

// A slice
const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        saveUserInfo: (state, action: PayloadAction<UserInfoDto>) => {
            state.userInfo = action.payload;
        },
        startLoading: (state) => {
            state.loading = true;
        },
        getUserInfoSuccess: (state, action: PayloadAction<UserInfoDto>) => {
            state.userInfo = action.payload;
            state.loading = false;
            state.hasErrors = false;
        },
        getUserInfoFailure: (state) => {
            state.loading = false;
            //handling Errors
            state.hasErrors = true;
        }
    },
});

export const {
    saveUserInfo,
    startLoading,
    getUserInfoFailure,
    getUserInfoSuccess,
} = userInfoSlice.actions;


// export user selector to get the slice in any component
export const userInfoSelector = (state: RootState) => state.userInfo;
// export The reducer
const userInfoReducer = userInfoSlice.reducer;
export default userInfoReducer;

